// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__9eUFh","hole":"styles_hole__Dm53E","info":"styles_info__TgYu6","gray":"styles_gray__zFemT"};